import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Alert } from 'antd';
import Loading from 'Common/Components/Loading';
import { DatevSettings } from 'utils/apiClient/services/datev/types';

import MissingSubPage from './MissingSubPage';
import PreWizard from './PreWizard';
import WizardAssistant from './WizardAssistant';

type SetupViewProps = {
  hasDatevSub: boolean;
  isLoading: boolean;
  isAuthenticated: boolean;
  hasTenant: boolean;
  datevSettings: DatevSettings;
  serverError: string | null;
};

const SetupView: React.FC<SetupViewProps> = ({
  isLoading,
  hasDatevSub,
  isAuthenticated,
  hasTenant,
  serverError,
}) => {
  const [wizardVisible, setWizardVisible] = useState(false);

  if (!hasDatevSub) {
    return <MissingSubPage />;
  }

  if (serverError) {
    return (
      <Alert
        message="Server Error"
        type="error"
        description={
          <FormattedMessage defaultMessage="We are currently experiencing issues with the server. Please come back later." />
        }
        showIcon
        data-testid="alert-component"
      />
    );
  }

  if (isLoading) {
    return <Loading />;
  }

  if (!isAuthenticated && wizardVisible) {
    return (
      <div css="margin-top: 20px">
        <WizardAssistant />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <PreWizard handleStartWizard={() => setWizardVisible(true)} />;
  }

  if (isAuthenticated && hasTenant) {
    return (
      <div css="margin-top: 20px">
        <WizardAssistant activeStep={3} />
      </div>
    );
  }

  if (isAuthenticated && !hasTenant) {
    return (
      <FormattedMessage
        defaultMessage="There is neither a company assigned nor a signed contract for Kassenarchiv Online. In order to send your data to Kassenarchiv online please complete the necessary steps at <link>https://www.datev.de/kassenarchiv</link>"
        values={{
          link: (m: React.ReactNode) => (
            <a
              href="https://www.datev.de/kassenarchiv"
              target="_blank"
              rel="noreferrer"
              data-testid="formatted-message"
            >
              {m}
            </a>
          ),
        }}
      />
    );
  }

  return <></>;
};

export default SetupView;
